import 'choerodon-ui/lib/tabs/style';
